import { FC } from 'react';
import { Flex, BoxProps } from '@chakra-ui/react';

export const PageWrapper: FC<BoxProps> = ({ children, ...props }) => (
  <Flex
    flexDir="column"
    overflowX="hidden"
    height="100%"
    pt={8}
    pr={6}
    pb="84px"
    pl={6}
    {...props}
  >
    {children}
  </Flex>
);
